(() => {
  if (window.r1GalleryImageZoomReady) return;
  window.r1GalleryImageZoomReady = true;
  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
  const imageSelector = '[data-r1d3-hero], [data-r1v2-slide][data-media-type="image"] > img';
  function initialize(root) {
    if (root.dataset.imageZoomReady === '1') return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-r1-image-zoom-data]').textContent); } catch (_) { return; }
    if (!data.images?.length) return;
    root.dataset.imageZoomReady = '1';
    const images = data.images;
    const labels = data.labels;
    let dialog, viewport, photo, level, counter, zoomIn, zoomOut;
    let index = 0, scale = 1, tx = 0, ty = 0, request = 0, returnFocus, previousOverflow = '';
    let gesture = null, pinch = null, tapBlockedUntil = 0;
    const pointers = new Map();
    const createButton = (label, text, action) => {
      const button = document.createElement('button');
      button.type = 'button';button.setAttribute('aria-label',label);button.title=label;button.textContent=text;
      let press=null, ignoreClickUntil=0;
      button.addEventListener('pointerdown',event=>{
        press=event.pointerType==='touch'||event.pointerType==='pen'
          ? {id:event.pointerId,x:event.clientX,y:event.clientY} : null;
      });
      button.addEventListener('pointercancel',()=>{press=null;});
      button.addEventListener('pointerup',event=>{
        const started=press;press=null;
        if(!started||started.id!==event.pointerId||button.disabled)return;
        const box=button.getBoundingClientRect();
        if(Math.hypot(event.clientX-started.x,event.clientY-started.y)>10
          ||event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)return;
        event.preventDefault();ignoreClickUntil=Date.now()+500;action(event);
      });
      button.addEventListener('click',event=>{
        if(button.disabled)return;
        if(event.detail!==0&&Date.now()<ignoreClickUntil){event.preventDefault();return;}
        action(event);
      });
      return button;
    };
    function bounds() {
      const width = viewport.clientWidth, height = viewport.clientHeight;
      const fit = Math.min(width / (photo.naturalWidth || width), height / (photo.naturalHeight || height));
      return {x:Math.max(0, ((photo.naturalWidth || width)*fit*scale-width)/2), y:Math.max(0, ((photo.naturalHeight || height)*fit*scale-height)/2)};
    }
    function apply() {
      const limit = bounds();tx=clamp(tx,-limit.x,limit.x);ty=clamp(ty,-limit.y,limit.y);
      photo.style.transform=`translate3d(${tx}px,${ty}px,0) scale(${scale})`;
      viewport.classList.toggle('is-zoomed',scale>1.01);
      level.textContent=Math.round(scale*100)+'%';
      zoomIn.disabled=scale>=3.99;zoomOut.disabled=scale<=1.01;
    }
    function fit() {scale=1;tx=0;ty=0;apply();}
    function point(event) {
      const box=viewport.getBoundingClientRect();
      return {x:event.clientX-box.left-box.width/2,y:event.clientY-box.top-box.height/2};
    }
    function zoom(next, at={x:0,y:0}) {
      next=clamp(next,1,4);const ratio=next/scale;
      tx=at.x-(at.x-tx)*ratio;ty=at.y-(at.y-ty)*ratio;scale=next;apply();
    }
    function render(next) {
      index=(next+images.length)%images.length;request+=1;pointers.clear();gesture=null;pinch=null;
      const current=request;photo.onload=()=>{if(current===request)apply();};
      photo.src=images[index].src;photo.alt=images[index].alt||'';fit();
      counter.textContent=(index+1)+' / '+images.length;
    }
    function resetGesture() {pointers.clear();gesture=null;pinch=null;viewport.classList.remove('is-dragging');}
    function makeDialog() {
      dialog=document.createElement('dialog');dialog.className='r1-image-zoom';dialog.setAttribute('aria-label',labels.title);
      const panel=document.createElement('div');panel.className='r1-image-zoom__panel';
      const bar=document.createElement('div');bar.className='r1-image-zoom__bar';
      const title=document.createElement('strong');title.textContent=labels.title;bar.append(title);
      const controls=document.createElement('div');controls.className='r1-image-zoom__tools';
      zoomOut=createButton(labels.out,'−',()=>zoom(scale/1.5));
      zoomIn=createButton(labels.in,'+',()=>zoom(scale*1.5));
      level=document.createElement('span');level.className='r1-image-zoom__level';level.setAttribute('aria-live','polite');
      const fitButton=createButton(labels.fit,labels.fit,fit);fitButton.dataset.zoomFit='';
      const close=createButton(labels.close,'×',()=>dialog.close());close.dataset.zoomClose='';
      controls.append(zoomOut,level,zoomIn,fitButton,close);bar.append(controls);
      viewport=document.createElement('div');viewport.className='r1-image-zoom__viewport';
      photo=document.createElement('img');photo.className='r1-image-zoom__photo';photo.alt='';photo.draggable=false;photo.decoding='async';viewport.append(photo);
      const footer=document.createElement('div');footer.className='r1-image-zoom__footer';
      const previous=createButton(labels.previous,'‹',()=>render(index-1));
      const next=createButton(labels.next,'›',()=>render(index+1));
      previous.disabled=next.disabled=images.length<2;
      counter=document.createElement('span');counter.className='r1-image-zoom__count';counter.setAttribute('aria-live','polite');
      footer.append(previous,counter,next);
      const help=document.createElement('p');help.className='r1-image-zoom__help';help.textContent=labels.help;
      panel.append(bar,viewport,footer,help);dialog.append(panel);document.body.append(dialog);
      dialog.addEventListener('click',event=>{
        if(event.target!==dialog)return;
        const box=panel.getBoundingClientRect();
        if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();
      });
      dialog.addEventListener('close',()=>{
        document.documentElement.style.overflow=previousOverflow;request+=1;resetGesture();
        if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});
      });
      dialog.addEventListener('keydown',event=>{
        if(event.key==='ArrowRight'){event.preventDefault();render(index+1);}
        if(event.key==='ArrowLeft'){event.preventDefault();render(index-1);}
        if(event.key==='+'||event.key==='='){event.preventDefault();zoom(scale*1.5);}
        if(event.key==='-'||event.key==='_'){event.preventDefault();zoom(scale/1.5);}
        if(event.key==='0'){event.preventDefault();fit();}
      });
      viewport.addEventListener('wheel',event=>{event.preventDefault();zoom(scale*Math.exp(-event.deltaY*.002),point(event));},{passive:false});
      viewport.addEventListener('pointerdown',event=>{
        if(event.button!==0)return;
        const p=point(event);pointers.set(event.pointerId,p);viewport.setPointerCapture(event.pointerId);
        if(pointers.size===1)gesture={id:event.pointerId,start:p,tx,ty,scale,dx:0,dy:0,moved:false};
        if(pointers.size===2){
          const [a,b]=Array.from(pointers.values());
          pinch={distance:Math.max(1,Math.hypot(a.x-b.x,a.y-b.y)),scale,tx,ty,center:{x:(a.x+b.x)/2,y:(a.y+b.y)/2}};
          gesture=null;tapBlockedUntil=Date.now()+500;
        }
      });
      viewport.addEventListener('pointermove',event=>{
        if(!pointers.has(event.pointerId))return;
        const p=point(event);pointers.set(event.pointerId,p);
        if(pointers.size>=2&&pinch){
          const [a,b]=Array.from(pointers.values());
          const next=clamp(pinch.scale*Math.hypot(a.x-b.x,a.y-b.y)/pinch.distance,1,4);
          const ratio=next/pinch.scale;
          tx=(a.x+b.x)/2-(pinch.center.x-pinch.tx)*ratio;
          ty=(a.y+b.y)/2-(pinch.center.y-pinch.ty)*ratio;scale=next;apply();tapBlockedUntil=Date.now()+500;return;
        }
        if(!gesture||gesture.id!==event.pointerId)return;
        gesture.dx=p.x-gesture.start.x;gesture.dy=p.y-gesture.start.y;
        if(Math.hypot(gesture.dx,gesture.dy)>8)gesture.moved=true;
        if(scale>1.01){tx=gesture.tx+gesture.dx;ty=gesture.ty+gesture.dy;apply();viewport.classList.toggle('is-dragging',gesture.moved);}
      });
      const finish=event=>{
        if(!pointers.has(event.pointerId))return;
        const ending=gesture;const pinching=Boolean(pinch);pointers.delete(event.pointerId);
        if(viewport.hasPointerCapture(event.pointerId))viewport.releasePointerCapture(event.pointerId);
        viewport.classList.remove('is-dragging');
        if(pinching){
          pinch=null;gesture=null;tapBlockedUntil=Date.now()+500;
          if(pointers.size===1){const [id,p]=Array.from(pointers.entries())[0];gesture={id,start:p,tx,ty,scale,dx:0,dy:0,moved:true};}
          return;
        }
        gesture=null;
        if(event.type==='pointercancel'||!ending)return;
        if(scale<=1.01&&ending.moved&&Math.abs(ending.dx)>=45&&Math.abs(ending.dx)>Math.abs(ending.dy)*1.25){render(index+(ending.dx<0?1:-1));tapBlockedUntil=Date.now()+400;}
        else if(!ending.moved&&Date.now()>=tapBlockedUntil){zoom(scale>1.01?1:2,point(event));}
      };
      viewport.addEventListener('pointerup',finish);viewport.addEventListener('pointercancel',finish);
      window.addEventListener('resize',()=>{if(dialog.open)apply();});
    }
    function open(next,trigger) {
      if(!dialog)makeDialog();
      if(dialog.open)return;
      returnFocus=trigger;previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden';dialog.showModal();render(next);
      root.querySelectorAll('r1-gallery-video').forEach(item=>item.pause?.());
      dialog.querySelector('[data-zoom-close]').focus();
    }
    function imageIndex(trigger) {
      const slide=trigger.closest('[data-r1v2-slide]');
      let id=slide?.dataset.mediaId;
      if(!id&&root.matches('[data-r1d3]'))id=root.querySelector('[data-r1d3-thumb].is-active')?.dataset.mediaId;
      if(id){const matched=images.findIndex(image=>String(image.id)===String(id));if(matched>=0)return matched;}
      const source=(trigger.dataset.src||trigger.currentSrc||trigger.src||'').split('?')[0];
      const found=images.findIndex(image=>new URL(image.src,location.href).pathname===new URL(source||location.href,location.href).pathname);
      return found>=0?found:0;
    }
    let start=null,moved=false;
    root.addEventListener('pointerdown',event=>{if(event.target.closest(imageSelector)||event.target.closest('[data-r1v2-thumb][data-media-type="image"]')){start={x:event.clientX,y:event.clientY};moved=false;}},{passive:true});
    root.addEventListener('pointermove',event=>{if(start&&Math.hypot(event.clientX-start.x,event.clientY-start.y)>10)moved=true;},{passive:true});
    root.addEventListener('pointercancel',()=>{moved=true;start=null;},{passive:true});
    root.addEventListener('click',event=>{
      const trigger=event.target.closest(imageSelector)||event.target.closest('[data-r1v2-thumb][data-media-type="image"]');
      if(!trigger||trigger.hidden||!trigger.getClientRects().length)return;
      if(!moved)open(imageIndex(trigger),trigger);start=null;moved=false;
    });
    root.querySelectorAll(imageSelector).forEach(image=>{
      image.tabIndex=0;image.setAttribute('role','button');image.setAttribute('aria-label',labels.open);image.setAttribute('aria-haspopup','dialog');
      image.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();open(imageIndex(image),image);}});
    });
  }
  const init=()=>document.querySelectorAll('[data-r1d3],[data-r1v2]').forEach(initialize);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
